import MultiEmail from './MultiEmail';
import EmailTag from './components/EmailTag';

export default MultiEmail;
export { EmailTag };
